import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output, QueryList,
    ViewChildren
} from '@angular/core';
import {
    IQuote,
    IWatabiLightBooking
} from "libraries/interfaces/watabilight/IWatabiLightBooking.interface";
import { Yii } from "libraries/interfaces/Yii";
import { FormGroup } from "@angular/forms";
import { IWatabiLightSectionDetails } from "libraries/interfaces/IWenji";
import { QuoteDetailsComponent } from "./quote-details/quote-details.component";

class Wording {
    public readonly title: string = Yii.t('wui-shared-js', 'Prix');
}

@Component({
    selector: 'watabilight-price',
    templateUrl: './price.component.html',
    styles: [`
        :host ::ng-deep .mat-tab-label-content {
            font-size: 1rem;
        }
    `],
    styleUrls: [
        '../../booking.component.scss'
    ]
})
export class PriceComponent implements OnInit {
    @Input()
    public booking: IWatabiLightBooking;
    @Input()
    public form: FormGroup;
    @Input()
    public travellersForm: FormGroup;
    @Input()
    public sectionConfig: IWatabiLightSectionDetails;
    @Input()
    public isEditable: boolean;

    @Output()
    public readonly onEdit: EventEmitter<number> = new EventEmitter();

    @ViewChildren('quote')
    public quoteComponent: QueryList<QuoteDetailsComponent>;

    public title: string;
    public description: string;


    public wording: Wording = new Wording();
    public isEdit: boolean = false;

    public ngOnInit(): void {
        this.title = this.sectionConfig?.title ? this.sectionConfig?.title : this.wording.title;
        this.description = this.sectionConfig?.description ? this.sectionConfig?.description : "";
        const quotes: IQuote[] = this.booking.quotes;
        quotes?.forEach((quote: IQuote): void => {
            this.form.addControl(quote.idItem.toString(), new FormGroup({}));
        });
    }

    public update(): void {
        this.quoteComponent.forEach((item: QuoteDetailsComponent): void => {
            item.update();
        });
    }

    public edit(): void {
        if (this.isEdit) {
            this.onEdit.emit(1);
        } else {
            this.onEdit.emit(5);
        }
        this.isEdit = !this.isEdit;
    }

}
